import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M20 10c0 5.547-4.492 10-10 10A9.97 9.97 0 0 1 0 10a9.94 9.94 0 0 1 2.969-7.11 1.25 1.25 0 0 1 1.797 0c.468.508.468 1.29-.04 1.758A7.6 7.6 0 0 0 2.5 10c0 4.14 3.32 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5 0-3.71-2.734-6.797-6.25-7.383V3.75C11.25 4.453 10.664 5 10 5c-.703 0-1.25-.547-1.25-1.25v-2.5C8.75.586 9.297 0 10 0c5.508 0 10 4.492 10 10m-9.375-.664c.39.39.39.976 0 1.328a.856.856 0 0 1-1.29 0L6.212 7.54c-.39-.351-.39-.937 0-1.328a.92.92 0 0 1 1.289 0z"
    }, null, -1)
  ])))
}
export default { render: render }